import { Directive, ElementRef, HostListener, inject, output } from "@angular/core";

/**
 * If this directive fires even for contained elements, use ClickStopPropagationDirective on those Angular components (but not on a "ng-container" element).
 */
@Directive({ selector: "[stagesClickOutside]" })
export class ClickOutsideDirective {
	private readonly nativeElement: Node;

	readonly stagesClickOutside = output<void>();

	constructor() {
		const elementRef = inject<ElementRef<Node>>(ElementRef);

		this.nativeElement = elementRef.nativeElement;
	}

	@HostListener("document:click", ["$event"])
	onClick(event: MouseEvent): void {
		const targetElement = event.target;

		if (!(targetElement instanceof Node)) {
			return;
		}

		let e: Node | null = targetElement;

		while (e) {
			if (e === this.nativeElement) {
				return;
			}
			e = e.parentElement;
		}
		// TODO: The 'emit' function requires a mandatory void argument
		this.stagesClickOutside.emit();
	}
}